import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface VersionRestoreConfirmDialogData {
  entityType: "flow" | "bundle";
  action: "restore" | "delete";
  /** Version to restore from, or to delete */
  version: number;
  /** Delete: whether this row is the live/current version */
  isCurrentVersion?: boolean;
  /** Delete: highest remaining version when deleting current */
  nextMainVersion?: number | null;
  /** Delete: live version when deleting a non-current row */
  liveVersion?: number | null;
}

@Component({
  selector: "app-version-restore-confirm-dialog",
  templateUrl: "./version-restore-confirm-dialog.component.html",
  styleUrls: ["./version-restore-confirm-dialog.component.scss"],
})
export class VersionRestoreConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<
      VersionRestoreConfirmDialogComponent,
      boolean
    >,
    @Inject(MAT_DIALOG_DATA) public data: VersionRestoreConfirmDialogData
  ) {}

  get entityLabel(): string {
    return this.data.entityType === "bundle" ? "bundle" : "flow";
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
